import { render, staticRenderFns } from "./workout-tracker-form.vue?vue&type=template&id=1a61feb8&"
import script from "./workout-tracker-form.vue?vue&type=script&lang=js&"
export * from "./workout-tracker-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports